module.exports = __webpack_public_path__ + "assets/img/top_border.edcb7e3a.png";